import { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
import  ACTIONS from "../../../pages/DesignAssets/Design_Asset_Actions.json";
import useCBMouserOver from "../../../pages/CustomHooks/useCBMouserOver";
const CircuitBreakerSVG = ({id,x,y,index, cbRequiredSelection, isEVCb = false,isLoad = false, dummyCB = false, configured = false, name=""}) => {
    const {
    CBAssetList,
    CBEVList,
    CBLoadList,
    UserScope,
    cbConfigDataHandler,
    CBAssetListDispatch,
    CBEVListDispatch,
    assetDetailsReset,
    callSnackbar,
    selectedValuesHandler,
    evCbConfigDataHandler
  } = useContext(DesignAssetContext);
  const AsstetList  = isLoad?CBLoadList:isEVCb ? CBEVList : CBAssetList;
  const [mouseOverData, CBMouseHandler] = useCBMouserOver();
    const cBSelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "cbAssetDetailsBlock";
      const selectedAssetValue = "selectedAssetCB";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_CB_SELECT,
        payload: {
          index: index,
        },
      });
      selectedValuesHandler(index, selectedAssetValue, assetBlock);
      cbConfigDataHandler(index);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
  const evCBSelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "cbEvDetailsBlock";
      const selectedAssetValue = "selectedEvCB";
      CBEVListDispatch({
        type: ACTIONS.EV_CB_SELECT,
        payload: {
          index,
        },
      });

      selectedValuesHandler(index, selectedAssetValue, assetBlock);
      evCbConfigDataHandler(index);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
    return (
        <g id={`CB${id}`}>
            <svg
                width="75px"
                height="100px"
                viewBox="0 0 10 149"
                x={x}
                y={y}
                onClick={dummyCB?null:cbRequiredSelection?isEVCb?evCBSelectHandler:cBSelectHandler :null}
                className="pointer"
            >
              <title>{name}</title>
                <g id="Circuit Breaker" fill="none" fillRule="evenodd">
                    <g
                        id="Circuit Breaker 1"
                        transform="translate(-651.000000, -512.000000)"
                        onMouseOver={dummyCB?null:cbRequiredSelection?CBMouseHandler:null}
                        onMouseOut={dummyCB?null:cbRequiredSelection?CBMouseHandler:null}
                    >
                        <g
                            id="Circuit Breaker - closed"
                            transform="translate(604.000000, 514.000000)"
                            fill={dummyCB?"none":
                                AsstetList?.[index]?.uiData.CBSelected
                                    ? "rgba(65, 181, 230, 0.35)"
                                    : mouseOverData
                                        ? "rgba(65, 181, 230, 0.35)"
                                        : "none"
                            }
                            stroke={dummyCB?"none":AsstetList?.[index]?.uiData.CBSelected ? "#42B4E6" : "none"}
                        >
                            <g id="Group-15" strokeWidth="4" fillRule="evenodd">
                                <rect
                                    id="Rectangle-Copy-22"
                                    x="0"
                                    y="12"
                                    width="96"
                                    height="122"
                                ></rect>
                                <g
                                    id="Group-2"
                                    transform="translate(48.000000, 0.000000)"
                                    stroke={(isLoad&&configured)?"var(--se-sld-circline)": dummyCB?"var(--se-sld-circline)":AsstetList?.[index]?.uiData.CBConfigured ? "var(--se-sld-circline)" : "#E47F00"}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="4"
                                >
                                    <line
                                        x1="0.5"
                                        y1="0"
                                        x2="0.5"
                                        y2="47.8298611"
                                        id="Line-2"
                                    ></line>
                                </g>
                            </g>
                            <line
                                x1="48.5"
                                y1="97.1701389"
                                x2="48.501111"
                                y2="145"
                                id="Line-2-Copy-15"
                                stroke={(isLoad&&configured)?"var(--se-sld-circline)":dummyCB?"var(--se-sld-circline)":AsstetList?.[index]?.uiData.CBConfigured ? "var(--se-sld-circline)" : "#E47F00"}
                                strokeWidth="4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></line>
                            <path
                                d="M49,48.6645651 C56.9440104,64.554855 56.9440104,80.5555556 49,96.6666667"
                                id="Path-11"
                                stroke={(isLoad&&configured)?"var(--se-sld-circline)":dummyCB?"var(--se-sld-circline)":AsstetList?.[index]?.uiData.CBConfigured ? "var(--se-sld-circline)" : "#E47F00"}
                                strokeWidth="4"
                                strokeLinecap="round"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        </g>
    );
};
export default CircuitBreakerSVG;
